export { default } from './DisplayWrapper';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/DisplayWrapper/index.js